export enum NavMenuPermission {
  ACCESS_MANUAL_PO = 'RPDMANPO',
  ACCESS_PAYMENT = 'RPDPAYMENT',
  ACCESS_CONFIGURATIONS = 'OWNRCNFG',
  ACCESS_ACCOUNT_MANAGEMENT = 'RACPAD_ACCTMGMT',
  ACCESS_REPORTS = 'RPDREPORTS',
  ACCESS_DAILY_ACTIVITY_PLANNER = 'RPDDAP',
  ACCESS_DOF = 'RPDDOF'
}
